import * as AllColors from "../constants/colors";

export function createAccordionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "red500";
  obj["default"] = "grey100";
  return obj;
}
export function createAnchorNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createAnswerCardMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "red500";
  obj["default"] = "white";
  return obj;
}
export function createBadgeMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createBasicTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createBreadcrumbMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createBottomDrawerMapDefinition() {
  let obj = {};
  obj["default"] = "red500";
  return obj;
}
export function createBulletListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createBusinesscardAuthorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createBusinesscardContactMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createBoxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "grey100";
  obj[AllColors["COLOR_NEUTRAL300"]] = "white";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "red500";
  obj[AllColors["COLOR_WHITE"]] = "red500";
  obj[AllColors["COLOR_NEUTRAL300"]] = "red500";
  obj[AllColors["COLOR_GREY100"]] = "red500";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "red500";
  return obj;
}
export function createCaptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_RED500GRADIENT"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createCardTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createCarouselMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "red500";
  obj[AllColors["COLOR_WHITE"]] = "red500";
  obj[AllColors["COLOR_NEUTRAL300"]] = "red500";
  obj[AllColors["COLOR_GREY100"]] = "red500";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "red500";
  return obj;
}
export function createCheckboxMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createChipMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "systemHighlight";
  obj[AllColors["COLOR_WHITE"]] = "systemHighlight";
  obj[AllColors["COLOR_NEUTRAL300"]] = "systemHighlight";
  obj[AllColors["COLOR_GREY100"]] = "systemHighlight";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "systemHighlight";
  return obj;
}
export function createClickableImageMapDefinition() {
  let obj = {};
  obj["default"] = "red500";
  return obj;
}
export function createColorSeparatorMapDefinition() {
  let obj = {};
  return obj;
}
export function createCompassMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createContactBarMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createContactLayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj["default"] = "white";
  return obj;
}
export function createContactListMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createContentAggregatorMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createContentAggregatorItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createContextMenuMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createContextMenuItemMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createDataTableMapDefinition() {
  let obj = {};
  return obj;
}
export function createDateEventMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createDatePickerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral300";
  obj[AllColors["COLOR_GREY100"]] = "grey100";
  obj[AllColors["COLOR_RED500"]] = "red500";
  obj["default"] = "white";
  return obj;
}
export function createDividerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createDropdownMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "white";
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_NEUTRAL300"]] = "white";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "red500";
  obj["default"] = "white";
  return obj;
}
export function createDropdownOptionMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral300";
  obj[AllColors["COLOR_GREY100"]] = "grey100";
  obj[AllColors["COLOR_RED500"]] = "red500";
  obj["default"] = "white";
  return obj;
}
export function createErrorMessageMapDefinition() {
  let obj = {};
  obj["default"] = "grey100";
  return obj;
}
export function createFileUploadMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "grey100";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_NEUTRAL300"]] = "white";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "red500";
  obj["default"] = "white";
  return obj;
}
export function createFilePreviewMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "grey100";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_NEUTRAL300"]] = "white";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createFooterBarMapDefinition() {
  let obj = {};
  return obj;
}
export function createFormMessageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "standard";
  return obj;
}
export function createHeadlineMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_RED100"]] = "neutral800";
  obj[AllColors["COLOR_RED300"]] = "neutral800";
  obj[AllColors["COLOR_YELLOW100"]] = "neutral800";
  obj[AllColors["COLOR_YELLOW300"]] = "neutral800";
  obj[AllColors["COLOR_TURQUOISE100"]] = "neutral800";
  obj[AllColors["COLOR_TURQUOISE300"]] = "neutral800";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "neutral800";
  return obj;
}
export function createHeadlineBrandMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "red500";
  obj[AllColors["COLOR_NEUTRAL100"]] = "red500";
  obj[AllColors["COLOR_GREY100"]] = "red500";
  obj[AllColors["COLOR_NEUTRAL300"]] = "red500";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "red500";
  return obj;
}
export function createHeroSectionMapDefinition() {
  let obj = {};
  obj["default"] = "red500";
  return obj;
}
export function createIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createImageMapDefinition() {
  let obj = {};
  return obj;
}
export function createInfoIconMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_NEUTRAL800"]] = "neutral100";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createInputMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral300";
  obj[AllColors["COLOR_GREY100"]] = "grey100";
  obj[AllColors["COLOR_RED500"]] = "red500";
  obj["default"] = "white";
  return obj;
}
export function createLinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createLinklistMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createMapMapDefinition() {
  let obj = {};
  return obj;
}
export function createMapInfoLayerMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createModalMapDefinition() {
  let obj = {};
  return obj;
}
export function createMultiContentStageMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_RED500GRADIENT"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createNavigationMapDefinition() {
  let obj = {};
  return obj;
}
export function createNumberMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createOffsetTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createOptionPickerItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createPaginationMapDefinition() {
  let obj = {};
  obj["default"] = "grey900";
  return obj;
}
export function createPreloaderCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "red500";
  obj[AllColors["COLOR_WHITE"]] = "red500";
  obj[AllColors["COLOR_NEUTRAL300"]] = "red500";
  obj[AllColors["COLOR_GREY100"]] = "red500";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "red500";
  return obj;
}
export function createPreloaderSquaresMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "red500";
  obj[AllColors["COLOR_WHITE"]] = "red500";
  obj[AllColors["COLOR_NEUTRAL300"]] = "red500";
  obj[AllColors["COLOR_GREY100"]] = "red500";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "red500";
  return obj;
}
export function createProgressCircleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "red500";
  obj[AllColors["COLOR_WHITE"]] = "red500";
  obj[AllColors["COLOR_NEUTRAL300"]] = "red500";
  obj[AllColors["COLOR_GREY100"]] = "red500";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "red500";
  return obj;
}
export function createPromoFlagMapDefinition() {
  let obj = {};
  obj["default"] = "red500";
  return obj;
}
export function createPageHeaderMapDefinition() {
  let obj = {};
  obj["default"] = "red500";
  return obj;
}
export function createPictogramMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createRadioButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createReadMoreMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "grey600";
  obj[AllColors["COLOR_WHITE"]] = "grey600";
  obj[AllColors["COLOR_NEUTRAL300"]] = "grey600";
  obj[AllColors["COLOR_GREY100"]] = "grey600";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey600";
  return obj;
}
export function createRteRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createSectionMapDefinition() {
  let obj = {};
  obj["default"] = "white";
  return obj;
}
export function createSegmentedButtonMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createSearchResultItemMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createSitelinkMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj["default"] = "grey900";
  return obj;
}
export function createSliderMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "systemHighlight";
  obj[AllColors["COLOR_WHITE"]] = "systemHighlight";
  obj[AllColors["COLOR_NEUTRAL300"]] = "systemHighlight";
  obj[AllColors["COLOR_GREY100"]] = "systemHighlight";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "systemHighlight";
  return obj;
}
export function createSwitchToggleMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createSpacerMapDefinition() {
  let obj = {};
  return obj;
}
export function createStageMapDefinition() {
  let obj = {};
  obj["default"] = "red500gradient";
  return obj;
}
export function createStatePillMapDefinition() {
  let obj = {};
  obj["default"] = "active";
  return obj;
}
export function createStepMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "grey900";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "grey900";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createStepsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "grey900";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "grey900";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createTableRendererMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createTabsMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createTabNavigationMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "grey900";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "grey900";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createTagPillMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "red500";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "red500";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED300"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "red500";
  return obj;
}
export function createTextMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral800";
  obj[AllColors["COLOR_WHITE"]] = "grey900";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral800";
  obj[AllColors["COLOR_GREY100"]] = "grey900";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj[AllColors["COLOR_GREY900"]] = "white";
  obj["default"] = "grey900";
  return obj;
}
export function createTextTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "grey100";
  return obj;
}
export function createThirdLevelNavigationMapDefinition() {
  let obj = {};
  obj["default"] = "grey100";
  return obj;
}
export function createThirdLevelNavigationItemMapDefinition() {
  let obj = {};
  obj["default"] = "grey100";
  return obj;
}
export function createTilesTeaserMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_NEUTRAL100"]] = "neutral300";
  obj[AllColors["COLOR_NEUTRAL300"]] = "neutral100";
  obj[AllColors["COLOR_WHITE"]] = "grey100";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createTooltipMapDefinition() {
  let obj = {};
  obj["default"] = "grey900";
  return obj;
}
export function createVideoplayerMapDefinition() {
  let obj = {};
  obj[AllColors["COLOR_WHITE"]] = "white";
  obj[AllColors["COLOR_NEUTRAL100"]] = "white";
  obj[AllColors["COLOR_GREY100"]] = "white";
  obj[AllColors["COLOR_NEUTRAL300"]] = "white";
  obj[AllColors["COLOR_RED500"]] = "white";
  obj["default"] = "white";
  return obj;
}
export function createViolatorMapDefinition() {
  let obj = {};
  obj["default"] = "red500";
  return obj;
}
export function createWebsiteNavigationMapDefinition() {
  let obj = {};
  return obj;
}
